import type { PortfolioData } from '../domain/portfolio.types';

export function About({ data }: { data: PortfolioData }) {
  return (
    <section className="section" id="about">
      <div className="container">
        <div className="reveal" style={{ marginBottom: 64 }}>
          <div className="section-tag">01 · About</div>
          <h2 className="section-title">
            Backend by instinct.<br/>
            <span className="alt">Full-stack</span> by training.
          </h2>
        </div>
        <div className="about-grid">
          <div className="about-body reveal">
            {data.about.paragraphs.map((p, i) => (
              <p key={i} dangerouslySetInnerHTML={{ __html: p }} />
            ))}
          </div>
          <div className="about-card reveal">
            <div className="about-card-title">// PROFILE.JSON</div>
            {data.about.facts.map((f, i) => (
              <div className="about-fact" key={i}>
                <span className="k">{f.k}</span>
                <span className="v">{f.v}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
